import React, { useState, useEffect } from 'react';
import './Sidebar.scss';
import { Link, useLocation } from 'react-router-dom';
import { IoIosArrowDown } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import Cookies from "js-cookie";
import { logoutAdmin } from "../redux/services/authService/authApi";
import { errorToast, successToast } from "../Utils/toast";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getInventoryMenuIds } from "../Utils/inventoryMenuMap";
import yaanjiLogo from '../../src/assets/image/yaanji-logo.png';
import { FaWallet, FaCrown } from "react-icons/fa";
import {
  MdDashboard,
  MdPeople,
  MdBusinessCenter,
  MdInventory,
  MdCategory,
  MdQuestionAnswer,
  MdNotificationsActive,
  MdGroups,
  MdCalendarMonth,
  MdEvent,
  MdSettings,
  MdLogout,
  MdChat,
  MdPhone,
  MdPhoneCallback,
  MdAssignment,
  MdCorporateFare,
  MdBrandingWatermark,
  MdStraighten,
  MdMiscellaneousServices,
  MdQuestionMark } from "react-icons/md";
import { getActiveModules } from "../redux/services/dashboardServices/dashboard.Services";
import { setLogin } from "../redux/features/authSlice";
import {
  getUserRole,
  isVendorAdmin as checkVendorAdmin,
  isStaff as checkStaff,
  isVisitAllowedUser,
  isSplitLeadVendor,
  getLoginType,          // ✅ Naya
  isStaffByLoginType,
} from "../Utils/role";
const Sidebar = ({ isOpen, onToggleSidebar }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const canShowVisit = isVisitAllowedUser();
  const [loading, setLoading] = useState(true)
  const [activeModules, setActiveModules] = useState([]);
  const [modulesLoaded, setModulesLoaded] = useState(false);;
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [allowedMenus, setAllowedMenus] = useState([]);
  const [noPermissionsFound, setNoPermissionsFound] = useState(false);
  const [activeMenu, setActiveMenu] = useState(() => {
    return localStorage.getItem("activeMenu") || "";
  });

  const { permissions, role: _rawRole, admin, token } = useSelector((state) => state.auth);
  const loginType = getLoginType();
  const isStaffUser = isStaffByLoginType();
  const role = typeof _rawRole === "string" ? _rawRole.toLowerCase() : "";
  const [isChatComingSoon, setIsChatComingSoon] = useState(false);
  const effectiveRole = role || getUserRole();
  const isVendorAdmin = checkVendorAdmin() || effectiveRole === "vender";
  const isStaff = checkStaff() || effectiveRole === "staff";
  const splitLeadVendor = isSplitLeadVendor();

  const buildTypedLeadChildren = (leadType) => {
    const query = `?lead_type=${leadType}`;
    return [
      {
        id: "newlead",
        title: "New",
        // href: isVendorAdmin
        //   ? `/new-lead-list${query}`
        //   : `/new-assign-lead-list${query}`,
         href: `/new-lead-list${query}`,

        permissionKey: "newlead",
      },
      {
        id: `${leadType}-pendinglead`,
        title: " Pending",
        href: isVendorAdmin
          ? `/vendor-pending-lead-list${query}`
          : `/staff-pending-lead-list${query}`,
        href: isVendorAdmin
          ? `/vendor-pending-lead-list${query}`
          : `/staff-pending-lead-list${query}`,
        permissionKey: "pendinglead",
      },
      {
        id: `${leadType}-alllead`,
        title: "Working Done",
        href: isVendorAdmin
          ? `/lead-list${query}`
          : `/other-lead-list${query}`,
        permissionKey: "alllead",
      },
    ];
  };

  const MODULE_MENU_MAP = {
    "Chat": ["chat"],
    "Reminder": ["reminder"],
    "Meeting": ["meeting"],
    "Enquiry": ["enquiry"],
    // "Leave": ["leave"],
    // "Calendar": ["calendar"],
    "Settings": ["content-setting"],
    // "Payment": ["paymentlsit", "paymentgatway"],
    // "Api Provider": ["apiProvider"],
    // "Cloud & Devops": ["cloud&devops"],
    // "Subscription": ["subscription"],
  };

  const MODULE_NAME_ALIAS = {
    // Leads / Calling family → "AI Calling"
    "lead management": ["ai calling"],
    "leads": ["ai calling"],
    "work lead": ["ai calling"],
    "investment lead": ["ai calling"],
    "newlead": ["ai calling"],
    "pendinglead": ["ai calling"],
    "alllead": ["ai calling"],
    "allcallinglist": ["ai calling"],
    "faq": ["ai calling"],
    "demo ai": ["ai calling"],

    // Inventory family → "Inventory Management"
    "inventorymanagement": ["inventory management"],
    "inventory": ["inventory management"],
    "category": ["inventory management"],
    "brand": ["inventory management"],
    "wherehouse": ["inventory management"],
    "product": ["inventory management"],
    "suppliers": ["inventory management"],
    "purchase": ["inventory management"],
    "stocktransfer": ["inventory management"],
  };

  const resolveModuleId = (item) => {
    if (!item || !activeModules.length) return null;

    const k1 = String(item.id || "").toLowerCase().trim();
    const k2 = String(item.title || "").toLowerCase().trim();

    // 1) direct match on item.id / item.title  (name ya slug se)
    let hit = activeModules.find((m) => {
      const n = String(m?.name || "").toLowerCase().trim();
      const s = String(m?.slug || "").toLowerCase().trim();
      return n === k1 || n === k2 || s === k1 || s === k2;
    });
    if (hit?.id != null) return hit.id;

    // 2) alias match (partial includes-based, taaki "Lead Management" ↔ "Lead" bhi chale)
    const aliases = [
      ...(MODULE_NAME_ALIAS[k1] || []),
      ...(MODULE_NAME_ALIAS[k2] || []),
    ];
    if (!aliases.length) return null;

    hit = activeModules.find((m) => {
      const n = String(m?.name || "").toLowerCase().trim();
      const s = String(m?.slug || "").toLowerCase().trim();
      return aliases.includes(n) || aliases.includes(s);
    });
    return hit?.id ?? null;
  };
  useEffect(() => {
    const loadModules = async () => {
      try {
        const res = await getActiveModules();
        const list = res?.data?.modules || [];
        setActiveModules(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Failed to load active modules", err);
      } finally {
        setModulesLoaded(true);
      }
    };
    loadModules();
  }, []);
  // const handleNoPermissionRedirect = (item) => {
  //   // Enquiry modal open karo (jaisa aapke pass already flow hai)
  //   // dispatch(
  //   //   openModal({
  //   //     type: "add-vendor-enquiry",
  //   //     title: "Enquiry",
  //   //     data: {
  //   //       module: null,
  //   //       module_id: null,
  //   //       module_name: item?.title || null,
  //   //     },
  //   //   })
  //   // );

  //  navigate("/our-services");

  // };


  const handleNoPermissionRedirect = (item) => {
    if (!item) return;

    const rawId = String(item.id || "").toLowerCase().trim();
    const rawTitle = String(item.title || "").toLowerCase().trim();
    let hit = activeModules.find((m) => String(m.id) === rawId);
    if (!hit) {
      hit = activeModules.find((m) => {
        const mName = String(m.name || "").toLowerCase().trim();
        const mSlug = String(m.slug || "").toLowerCase().trim();
        return (
          mName === rawTitle ||
          mName === rawId ||
          mSlug === rawId ||
          mSlug === rawTitle.replace(/\s+/g, "-")
        );
      });
    }
    if (!hit) {
      const aliases = [
        ...(MODULE_NAME_ALIAS[rawId] || []),
        ...(MODULE_NAME_ALIAS[rawTitle] || []),
      ];
      if (aliases.length > 0) {
        hit = activeModules.find((m) => {
          const mName = String(m.name || "").toLowerCase().trim();
          const mSlug = String(m.slug || "").toLowerCase().trim();
          return aliases.includes(mName) || aliases.includes(mSlug);
        });
      }
    }
    if (!hit) {
      hit = activeModules.find(m => String(m.name).toLowerCase() === "others") || activeModules[0];
    }
    if (hit && hit.id) {
      navigate(`/module-features/${hit.id}`);
    } else {
      navigate("/our-services");
    }
  };

  // useEffect(() => {
  //     const fetchPermissions = async () => {
  //       try {
  //         const tokenFromCookie = localStorage.getItem("adminToken");
  //         const staffData = localStorage.getItem("admin");
  //         const response = await fetch(
  //           `${process.env.REACT_APP_API_BASE_URL}/vendor/vendor-permissions-show`,
  //           {
  //             method: "GET",
  //             headers: {
  //               Authorization: `Bearer ${tokenFromCookie}`,
  //               Accept: "application/json",
  //               "Content-Type": "application/json",
  //             },
  //           }
  //         );
  //         const result = await response.json();
  //         const applyLogin = (
  //           allowedMenusArr,
  //           roleValue,
  //           userId = null,
  //           categoryId = null,
  //           subcategoryId = null,
  //           subcategorySlug = null
  //         ) => {
  //           let roleString = "vender";
  //           if (typeof roleValue === "string") {
  //             roleString = roleValue;
  //           } else if (roleValue && typeof roleValue === "object") {
  //             roleString = roleValue.name || roleValue.slug || roleValue.role || "vender";
  //           }

  //           dispatch(
  //             setLogin({
  //               admin: admin || JSON.parse(staffData || "{}"),
  //               token: tokenFromCookie,
  //               role: roleString,
  //               permissions: allowedMenusArr.length
  //                 ? { allowedMenus: allowedMenusArr }
  //                 : {},
  //               user_id: userId,
  //               category_id: categoryId,
  //               subcategory_id: subcategoryId,
  //               subcategory_slug: subcategorySlug,
  //             })
  //           );
  //         };

  //         if (result.success && Array.isArray(result.data) && result.data.length > 0) {
  //           const menuIds = new Set();
  //           let inventoryUserId = null;
  //           let inventoryCategoryId = null;
  //           let inventorySubcategoryId = null;
  //           let inventorySubcategorySlug = null;
  //           let hasModuleLevelLeadPerm = false;
  //           let hasModuleLevelInventoryPerm = false;

  //           result.data.forEach((perm) => {
  //             const moduleName = perm.module?.name?.trim();
  //             const categoryName = perm.category?.name?.trim();
  //             const subcategoryName = perm.subcategory?.name?.trim();
  //             const normalizedModule = moduleName?.toLowerCase() || "";
  //             const isAiCalling =
  //               normalizedModule.includes("ai calling") ||
  //               categoryName?.toLowerCase() === "ai calling";

  //             if (normalizedModule.includes("lead") || isAiCalling) {
  //               const isModuleLevel = !perm.category_id && !perm.subcategory_id;
  //               if (isModuleLevel && normalizedModule.includes("lead")) {
  //                 hasModuleLevelLeadPerm = true;
  //               } else if (categoryName === "Staff") {
  //                 menuIds.add("staff-management");
  //               } else if (isAiCalling || categoryName === "AI Calling") {
  //                 menuIds.add("Lead Management");
  //                   menuIds.add("staff-management");
  //               }
  //               return;
  //             }
  //             if (normalizedModule.includes("inventory")) {
  //               const isModuleLevel = !perm.category_id && !perm.subcategory_id;
  //               if (isModuleLevel) {
  //                 hasModuleLevelInventoryPerm = true;
  //                 return;
  //               }
  //               const inventoryMenuIds = getInventoryMenuIds(categoryName, subcategoryName);
  //               inventoryMenuIds.forEach((id) => menuIds.add(id));
  //               menuIds.add("inventoryManagement");
  //               return;
  //             }

  //             if (moduleName && MODULE_MENU_MAP[moduleName]) {
  //               MODULE_MENU_MAP[moduleName].forEach((id) => menuIds.add(id));
  //             }
  //           });

  //           if (
  //             hasModuleLevelLeadPerm &&
  //             !menuIds.has("Lead Management") &&
  //             !menuIds.has("staff-management")
  //           ) {
  //             menuIds.add("Lead Management");
  //             menuIds.add("staff-management");
  //           }

  //           if (
  //             hasModuleLevelInventoryPerm &&
  //             !menuIds.has("inventoryManagement")
  //           ) {
  //             const hasAnyInventoryChild = [
  //               "category", "subcategory", "brand", "unit", "color",
  //               "size", "wherehouse", "product", "purchase", "stocktransfer",
  //             ].some((id) => menuIds.has(id));

  //             if (!hasAnyInventoryChild) {
  //               menuIds.add("inventoryManagement");
  //             }
  //           }     
  //           const finalMenus = Array.from(menuIds);
  //           setAllowedMenus(finalMenus);
  //           setNoPermissionsFound(finalMenus.length === 0);
  //           applyLogin(
  //             finalMenus,
  //             result.data[0]?.vendor?.role,
  //             inventoryUserId,
  //             inventoryCategoryId,
  //             inventorySubcategoryId,
  //             inventorySubcategorySlug
  //           );
  //         } else {
  //           setNoPermissionsFound(true);
  //           setAllowedMenus([]);
  //           applyLogin([], role);
  //         }
  //       } catch (error) {
  //         console.log(error);
  //         setNoPermissionsFound(true);
  //         setAllowedMenus([]);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchPermissions();
  //   }, [dispatch]);
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const tokenFromCookie = localStorage.getItem("adminToken");
        const staffData = localStorage.getItem("admin");
        const loginType = localStorage.getItem("login_type"); // ✅ ADD

        // ✅ ADD: URL decide karein
        const url = loginType === "staff"
          ? `${process.env.REACT_APP_API_BASE_URL}/vendor/staff-permissions-show`
          : `${process.env.REACT_APP_API_BASE_URL}/vendor/vendor-permissions-show`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenFromCookie}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();

        const applyLogin = (
          allowedMenusArr,
          roleValue,
          userId = null,
          categoryId = null,
          subcategoryId = null,
          subcategorySlug = null
        ) => {
          let roleString = "vender";
          if (typeof roleValue === "string") {
            roleString = roleValue;
          } else if (roleValue && typeof roleValue === "object") {
            roleString = roleValue.name || roleValue.slug || roleValue.role || "vender";
          }

          dispatch(
            setLogin({
              admin: admin || JSON.parse(staffData || "{}"),
              token: tokenFromCookie,
              role: roleString,
              permissions: allowedMenusArr.length
                ? { allowedMenus: allowedMenusArr }
                : {},
              user_id: userId,
              category_id: categoryId,
              subcategory_id: subcategoryId,
              subcategory_slug: subcategorySlug,
            })
          );
        };
        if (loginType === "staff") {
          const menuIds = new Set();
          const staffPerms = Array.isArray(result?.data) ? result.data : [];

          const MODULE_MAP = {
            "leads": "Lead Management",
            "lead": "Lead Management",
            "ai calling": "Lead Management",
            "chat": "chat",

          };
          const LEAD_CHILD_MAP = {
            "new": "newlead",
            "pending": "pendinglead",
            "others": "alllead",
            "calling list": "allcallinglist",
            "faq": "faq",
          };

          staffPerms.forEach((perm) => {
            const mod = String(perm?.module || "").toLowerCase().trim();
            const perms = Array.isArray(perm?.permissions) ? perm.permissions : [];
            const parentId = MODULE_MAP[mod];
            if (parentId && perms.length > 0) {
              menuIds.add(parentId);
              if (parentId === "Lead Management") {
                perms.forEach((p) => {
                  const childId = LEAD_CHILD_MAP[String(p).toLowerCase().trim()];
                  if (childId) menuIds.add(childId);
                });
              }
            }
          });
          const finalMenus = Array.from(menuIds);
          setAllowedMenus(finalMenus);
          setNoPermissionsFound(finalMenus.length === 0);
          const staffAdmin = staffData ? JSON.parse(staffData) : {};
          applyLogin(
            finalMenus,
            staffAdmin?.role || "staff",
            staffAdmin?.user_id,
            staffAdmin?.category_id,
            staffAdmin?.subcategory_id,
            staffAdmin?.subcategory_slug
          );

          setLoading(false);
          return;
        }

        if (result.success && Array.isArray(result.data) && result.data.length > 0) {
          const menuIds = new Set();
          let inventoryUserId = null;
          let inventoryCategoryId = null;
          let inventorySubcategoryId = null;
          let inventorySubcategorySlug = null;
          let hasModuleLevelLeadPerm = false;
          let hasModuleLevelInventoryPerm = false;

          result.data.forEach((perm) => {
            const moduleName = perm.module?.name?.trim();
            const categoryName = perm.category?.name?.trim();
            const subcategoryName = perm.subcategory?.name?.trim();
            const normalizedModule = moduleName?.toLowerCase() || "";
            const isAiCalling =
              normalizedModule.includes("ai calling") ||
              categoryName?.toLowerCase() === "ai calling";

            if (normalizedModule.includes("lead") || isAiCalling) {
              const isModuleLevel = !perm.category_id && !perm.subcategory_id;
              if (isModuleLevel && normalizedModule.includes("lead")) {
                hasModuleLevelLeadPerm = true;
              } else if (categoryName === "Staff") {
                menuIds.add("staff-management");
              } else if (isAiCalling || categoryName === "AI Calling") {
                menuIds.add("Lead Management");
                menuIds.add("staff-management");
              }
              return;
            }
            if (normalizedModule.includes("inventory")) {
              const isModuleLevel = !perm.category_id && !perm.subcategory_id;
              if (isModuleLevel) {
                hasModuleLevelInventoryPerm = true;
                return;
              }
              const inventoryMenuIds = getInventoryMenuIds(categoryName, subcategoryName);
              inventoryMenuIds.forEach((id) => menuIds.add(id));
              menuIds.add("inventoryManagement");
              return;
            }

            if (moduleName && MODULE_MENU_MAP[moduleName]) {
              MODULE_MENU_MAP[moduleName].forEach((id) => menuIds.add(id));
            }
          });

          if (
            hasModuleLevelLeadPerm &&
            !menuIds.has("Lead Management") &&
            !menuIds.has("staff-management")
          ) {
            menuIds.add("Lead Management");
            menuIds.add("staff-management");
          }

          if (
            hasModuleLevelInventoryPerm &&
            !menuIds.has("inventoryManagement")
          ) {
            const hasAnyInventoryChild = [
              "category", "subcategory", "brand", "unit", "color",
              "size", "wherehouse", "product", "purchase", "stocktransfer",
            ].some((id) => menuIds.has(id));

            if (!hasAnyInventoryChild) {
              menuIds.add("inventoryManagement");
            }
          }

          const finalMenus = Array.from(menuIds);
          setAllowedMenus(finalMenus);
          setNoPermissionsFound(finalMenus.length === 0);
          applyLogin(
            finalMenus,
            result.data[0]?.vendor?.role,
            inventoryUserId,
            inventoryCategoryId,
            inventorySubcategoryId,
            inventorySubcategorySlug
          );
        } else {
          setNoPermissionsFound(true);
          setAllowedMenus([]);
          applyLogin([], role);
        }
      } catch (error) {
        console.log(error);
        setNoPermissionsFound(true);
        setAllowedMenus([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPermissions();
  }, []);



  const navigate = useNavigate();
  const ALWAYS_ALLOWED_IDS = ["dashboard"];
  const isItemAllowed = (item) => {
    if (!item) return false;
    if (isStaffUser) {
      if (item.id === "staff-management") return false; // Employees hide
      if (item.dropdown) {
        // Dropdown tabhi dikhega jab uske andar ka koi child allowed ho
        return item.children?.some((child) => allowedMenus.includes(child.id)) || false;
      }
      return allowedMenus.includes(item.id); // Normal items
    }
    if (splitLeadVendor) return true;
    if (ALWAYS_ALLOWED_IDS.includes(item.id)) return true;
    if (isStaffUser) {
      return item.children?.some((child) => allowedMenus.includes(child.id)) || false;
    }
    if (item.id === "visit") return canShowVisit;
    if (item.id === "otherServices") return true;
    if (item.id === "subscription") return allowedMenus.length > 0;
    if (item.id === "enquiry") return allowedMenus.length > 0;
    if (item.id === "logout") return true;


    // Dropdown: parent allowed HO ya koi child allowed ho
    if (item.dropdown) {
      if (
        (item.id === "Work Lead" || item.id === "Investment Lead") &&
        allowedMenus.includes("Lead Management")
      ) {
        return true;
      }
      if (allowedMenus.includes(item.id)) return true;
      return item.children?.some((child) => allowedMenus.includes(child.id)) || false;
    }

    return allowedMenus.includes(item.id);
  };

  const isChildAllowed = (parentItem, child) => {
    if (isStaffUser) {
      return allowedMenus.includes(child.id); 
    }
    if (splitLeadVendor) return true;
    if (isStaffUser) {
      return allowedMenus.includes(child.id);
    }
    if (allowedMenus.includes(parentItem.id)) return true;
    if (
      (parentItem.id === "Work Lead" || parentItem.id === "Investment Lead") &&
      allowedMenus.includes("Lead Management")
    ) {
      return true;
    }
    return allowedMenus.includes(child.id);
  };
  const shouldShowItem = (item) => {
    if (isStaffUser) {
      const hiddenForStaff = [
        "dashboard",
        "visit",
        "subscription",
        "chat",
        "Demo Ai",
        "otherServices",
        "enquiry"
      ];
      if (hiddenForStaff.includes(item.id)) return false;
      if (item.id === "staff-management") return false;
    }
    if (item.id === "visit") return canShowVisit;
    // if (isStaff && item.id === "staff-management") return false;

    return true;
  };
  const fullMenuItems = [
    {
      items: [
        {
          id: "dashboard",
          title: "Dashboard",
          href: isVendorAdmin
            ? "/"
            : permissions?.dashboard == 1
              ? "/"
              : "/staff-dashboard",
          icon: <MdDashboard />,
        },
        {
          id: "visit",
          title: "Shedule",
          href: "/shedule-list",
          permissionKey: "visit",
          icon: <MdPeople />,
        },
        {
          id: "staff-management",
          title: "Employees",
          permissionKey: "staff",
          dropdown: true,
          icon: <MdGroups />,
          children: [
            {
              id: "staff",
              title: "Employes",
              href: "/staff-list",
              permissionKey: "staff",
              icon: <MdPeople />,
            },
            {
              id: "role",
              title: "Roles",
              href: "/role-list",
              permissionKey: "role",
              icon: <MdAssignment />,
            },
            {
              id: "department",
              title: "Departments",
              href: "/deparment-list",
              permissionKey: "department",
              icon: <MdCorporateFare />,
            },
          ],
        },
        ...(splitLeadVendor
          ? [
            {
              id: "Work Lead",
              title: "Work Lead",
              permissionKey: "lead",
              dropdown: true,
              icon: <MdBusinessCenter />,
              children: buildTypedLeadChildren("work"),
            },
            {
              id: "Investment Lead",
              title: "Investment Lead",
              permissionKey: "lead",
              dropdown: true,
              icon: <MdBusinessCenter />,
              children: buildTypedLeadChildren("investment"),
            },
          ]
          : [
            {
              id: "Lead Management",
              title: "Leads",
              permissionKey: "lead",
              dropdown: true,
              icon: <MdBusinessCenter />,
              children: [
                {
                  id: "newlead",
                  title: "New",
                  // href: isVendorAdmin ? "/new-lead-list" : "/new-assign-lead-list",
                  href: "/new-lead-list",
                  permissionKey: "newlead",
                },
                {
                  id: "pendinglead",
                  title: " Pending",
                  href: "/vendor-pending-lead-list",
                  // href: isVendorAdmin ? "/vendor-pending-lead-list" : "/staff-pending-lead-list",
                  permissionKey: "pendinglead",
                },
                {
                  id: "alllead",
                  title: "Others",
                  // href: isVendorAdmin ? "/lead-list" : "/other-lead-list",
                  href: "/lead-list",
                  permissionKey: "alllead",
                },
                {
                  id: "allcallinglist",
                  title: "Calling List",
                  href: "/all-calling-list",
                  permissionKey: "allcallinglist",
                },
                {
                  id: "faq",
                  title: "FAQ",
                  href: "/faq",
                  permissionKey: "faq",
                  icon: <MdQuestionAnswer />,
                },
              ],
            },
          ]),
        {
          id: "subscription",
          title: "My Subscriptions",
          href: "/my-subscriptions",
          icon: <FaCrown />,
          permissionKey: "subscription",
        },
        // {
        //   id: "inventoryManagement",
        //   title: "Inventory",
        //   permissionKey: "inventoryManagement",
        //   dropdown: true,
        //   icon: <MdInventory />,
        //   children: [
        //     {
        //       id: "category",
        //       title: "Categories",
        //       href: "/categories-list",
        //       icon: <MdCategory />,
        //       permissionKey: "category",
        //     },
        //     {
        //       id: "brand",
        //       title: "Brand",
        //       href: "/brand-list",
        //       icon: <MdBrandingWatermark />,
        //       permissionKey: "brand",
        //     },
        //     {
        //       id: "wherehouse",
        //       title: "WhereHouses",
        //       href: "/wherehouse-list",
        //       icon: <MdStraighten />,
        //       permissionKey: "wherehouse",
        //     },
        //     {
        //       id: "product",
        //       title: "Products",
        //       href: "/product-list",
        //       icon: <MdCategory />,
        //       permissionKey: "product",
        //     },
        //     {
        //       id: "suppliers",
        //       title: "Suppliers",
        //       href: "/supplier-list",
        //       icon: <MdCategory />,
        //       permissionKey: "product",
        //     },
        //     {
        //       id: "purchase",
        //       title: "Purchases",
        //       href: "/purchase-list",
        //       icon: <MdCategory />,
        //       permissionKey: "purchase",
        //     },
        //     {
        //       id: "stocktransfer",
        //       title: "Stock Transfer",
        //       href: "/transfer-inventroy-list",
        //       icon: <MdCategory />,
        //       permissionKey: "stocktransfer",
        //     },
        //   ],
        // },
        // {
        //   id: "apiProvider",
        //   title: "Api Provider List",
        //   href: "/api-provider-list",
        //   permissionKey: "apiProvider",
        //   icon: <MdPeople />,
        // },
        // {
        //   id: "cloud&devops",
        //   title: "Cloud & Dev Ops",
        //   href: "/api-provider-list",
        //   permissionKey: "devops",
        //   icon: <MdPeople />,
        // },
        // {
        //   id: "paymentgatway",
        //   title: "Payment Gateway Intigration",
        //   href: "/business-category-list",
        //   permissionKey: "paymentgatway",
        //   icon: <MdPeople />,
        // },
        // {
        //   id: "paymentlsit",
        //   title: "Payment List",
        //   href: "/Payment-list",
        //   permissionKey: "paymentlsit",
        //   icon: <MdPeople />,
        // },
        {
          id: "chat",
          title: "Chat",
          href: "/chat",
          icon: <MdChat />,
          permissionKey: "chat",
          isComingSoon: true,
        },
        {
          id: "Demo Ai",
          title: "AI Agent Demo Call",
          href: "/create-demo-call",
          icon: <MdChat />,
          permissionKey: "demo",
        },
        {
          id: "otherServices",
          title: "Other Services",
          href: "/our-services",
          isSpecial: true, // Custom flag for styling
          icon: <MdMiscellaneousServices />,
        },
        // {
        //   id: "reminder",
        //   title: "Reminder",
        //   href: "/reminder-list",
        //   icon: <MdNotificationsActive />,
        //   permissionKey: "reminder",
        // },
        // {
        //   id: "meeting",
        //   title: "Meeting",
        //   href: "/meeting-list",
        //   icon: <MdEvent />,
        //   permissionKey: "meeting",
        // },
        {
          id: "enquiry",
          title: "Enquiry List",
          href: "/enquries-list",
          icon: <MdEvent />,
          permissionKey: "enquiry",
        },
        // {
        //   id: "leave",
        //   title: "Leave",
        //   href: "/leave",
        //   icon: <MdAssignment />,
        //   permissionKey: "leave",
        // },
        // {
        //   id: "calendar",
        //   title: "Calendar",
        //   href: "/calendar",
        //   icon: <MdCalendarMonth />,
        //   permissionKey: "calendar",
        // },
        // {
        //   id: "content-setting",
        //   title: "Content / Setting",
        //   href: "/content-setting",
        //   icon: <MdSettings />,
        //   permissionKey: "settings",
        // },
        {
          id: "logout",
          title: "Logout",
          action: "logout",
          icon: <MdLogout />,
        },
      ],
    },
  ];

  const splitMenuItems = [
    {
      items: [
        {
          id: "dashboard",
          title: "Dashboard",
          href: "/",
          icon: <MdDashboard />,
        },
        {
          id: "Work Lead",
          title: "Associate Lead",
          dropdown: true,
          icon: <MdBusinessCenter />,
          children: buildTypedLeadChildren("work"),
        },
        // {
        //   id: "Investment Lead",
        //   title: "Investment Lead",
        //   dropdown: true,
        //   icon: <MdBusinessCenter />,
        //   children: buildTypedLeadChildren("investment"),
        // },
        {
          id: "work-schedule",
          title: "Accocate Schedule leads ",
          href: "/schedule-list?lead_type=work",
          icon: <MdCalendarMonth />,
        },
        // {
        //   id: "investment-schedule",
        //   title: "Investment Schedule",
        //   href: "/schedule-list?lead_type=investment",
        //   icon: <MdEvent />,
        // },
        {
          id: "subscription",
          title: "Subscription",
          href: "/my-subscriptions",
          icon: <FaCrown />,
        },
        {
          id: "work-calling",
          title: "Associate Calling History",
          href: "/all-calling-list?lead_type=work",
          icon: <MdPhone />,
        },
        // {
        //   id: "investment-calling",
        //   title: "Investment Calling History",
        //   href: "/all-calling-list?lead_type=investment",
        //   icon: <MdPhone />,
        // },
        {
          id: "work-callbacks",
          title: "Associate Schedule Calls",
          href: "/callback-list?lead_type=work",
          icon: <MdPhoneCallback />,
        },
        {
          id: "ai-questions",
          title: "Bugs",
          href: "/ai-questions-list?lead_type=work",
          icon: <MdQuestionMark />,
        },
        // {
        //   id: "investment-callbacks",
        //   title: "Investment Callbacks",
        //   href: "/callback-list?lead_type=investment",
        //   icon: <MdPhoneCallback />,
        // },
        {
          id: "logout",
          title: "Logout",
          action: "logout",
          icon: <MdLogout />,
        },
      ],
    },
  ];

  const menuItems = splitLeadVendor ? splitMenuItems : fullMenuItems;
  const handleLogout = async () => {
    try {
      await logoutAdmin();
      localStorage.removeItem("adminToken");
      localStorage.clear();
      successToast("Logged out successfully");
      navigate("/login");
    } catch (error) {
      console.log(error);
      localStorage.removeItem("adminToken");
      localStorage.clear();
      navigate("/login");
      errorToast("Logout failed but session cleared");
    }
  };

  useEffect(() => {
    const currentPath = `${location.pathname}${location.search}`;
    menuItems.forEach((section) => {
      section.items.forEach((item) => {
        if (item.href === currentPath || item.href === location.pathname) {
          setActiveMenu(item.id);
          localStorage.setItem("activeMenu", item.id);
        }
        if (item.children) {
          item.children.forEach((child) => {
            if (child.href === currentPath || (!child.href?.includes("?") && child.href === location.pathname)) {
              setActiveMenu(child.id);
              setActiveDropdown(item.id);
              localStorage.setItem("activeMenu", child.id);
            }
          });
        }
      });
    });
  }, [location.pathname, location.search]);

  const toggleDropdown = (dropdownId) => {
    setActiveDropdown((prev) =>
      prev === dropdownId ? null : dropdownId
    );
  };

  const permissionsLoaded =
    permissions && Object.keys(permissions).length > 0;

  const isAdmin = role?.toLowerCase() === "admin";

  const canAccess = (permissionKey) => {
    if (isAdmin) return true;
    if (!permissionsLoaded) return false;
    if (!permissionKey) return true;
    return permissions?.[permissionKey] == 1;
  };

  // ============================================================
  // RENDER MENU ITEM
  // ============================================================
  const renderMenuItem = (item) => {
    // Logout special
    if (item.action === "logout") {
      return (
        <li key={item.id} className={`menu-item ${activeMenu === item.id ? "active" : ""}`}>
          <div
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
          </div>
        </li>
      );
    }
    if (item.isComingSoon) {
      return (
        <li key={item.id} className="menu-item">
          <div
            className="menu-link"
            onClick={() => setIsChatComingSoon(true)}
            style={{ cursor: "pointer" }}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>

            <span className="badge-soon ms-auto">Soon</span>

          </div>
        </li>
      );
    }
    const isDropdownOpen = activeDropdown === item.id;
    const allowed = isItemAllowed(item);

    return (
      <li key={item.id} className={`menu-item ${activeMenu === item.id ? "active" : ""}`}>
        {item.dropdown ? (
          <a
            href="#"
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              toggleDropdown(item.id);
              setActiveMenu(item.id);
            }}
            style={!allowed ? { opacity: 0.75 } : {}}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
            <span className={`menu-arrow ${isDropdownOpen ? "rotate" : ""}`}>
              <IoIosArrowDown />
            </span>
          </a>
        ) : item.isSpecial && allowed ? (
          <Link
            to={item.href}
            className={`menu-link special-menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={() => setActiveMenu(item.id)}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
            <span className="badge-pro">NEW</span>
          </Link>
        ) : allowed ? (
          // ✅ Allowed — clickable Link
          <Link
            to={item.href}
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            onClick={() => setActiveMenu(item.id)}
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
          </Link>
        ) : (
          // ❌ Not allowed — dikhega lekin disabled
          <div
            className={`menu-link ${activeMenu === item.id ? "active" : ""}`}
            // style={{ cursor: "not-allowed", opacity: 0.5 }}
            style={{ cursor: "pointer", opacity: 0.75 }}
            // onClick={(e) => e.preventDefault()}
            onClick={() => handleNoPermissionRedirect(item)}
            // title="No permission"
            title="Upgrade to access"
          >
            {item.icon && <span className="menu-icon">{item.icon}</span>}
            <span className="menu-text">{item.title}</span>
          </div>
        )}

        {item.dropdown && isDropdownOpen && (
          <div className="collapse show">
            <ul className="sub-menu">
              {item.children
                .filter((child) => {
                  // ✅ Staff ke liye sirf allowed children dikhao
                  if (isStaffUser) {
                    return allowedMenus.includes(child.id);
                  }
                  return true;
                })
                .map((child) => {
                  const childAllowed = isChildAllowed(item, child);
                  return (
                    <li
                      key={child.id}
                      className={`menu-item ${activeMenu === child.id ? "active" : ""}`}
                    >
                      {childAllowed ? (
                        <Link
                          to={child.href}
                          onClick={() => setActiveMenu(child.id)}
                          className={`menu-link ${activeMenu === child.id ? "active" : ""}`}
                        >
                          <span className="menu-text">{child.title}</span>
                        </Link>
                      ) : (
                        <div
                          className={`menu-link ${activeMenu === child.id ? "active" : ""}`}
                          // style={{ cursor: "not-allowed", opacity: 0.5 }}
                          // onClick={(e) => e.preventDefault()}
                          // title="No permission"
                          style={{ cursor: "pointer", opacity: 0.75 }}
                          onClick={() => handleNoPermissionRedirect(child)}
                          title="Upgrade to access"
                        >
                          <span className="menu-text">{child.title}</span>
                        </div>
                      )}
                    </li>
                  );
                })}
            </ul>
          </div>
        )}
      </li>
    );
  };

  return (
    <div className={`sidebar position-relative ${!isOpen ? 'closed' : ''}`}>
      {!isOpen && (
        <div
          className="overlaysidebar"
          onClick={onToggleSidebar}
        ></div>
      )}
      {!isOpen && (
        <div
          className="closebutton"
          onClick={onToggleSidebar}
        >
          <IoMdClose />
        </div>
      )}

      <div className={`main-menu ${isOpen ? '' : 'active'}`}>
        <div className="logo-box">
          <Link className="logo-light" to="/">
            <div className="sidbar-logo">
              <img src={yaanjiLogo} alt="Yaanji Logo" />
            </div>
          </Link>
        </div>
        <div className="sidebar-content">
          <ul className="app-menu">
            {menuItems.map((section, index) => (
              <React.Fragment key={index}>
                {section.items
                  .filter((item) => shouldShowItem(item))
                  .map((item) => renderMenuItem(item))}
              </React.Fragment>
            ))}
          </ul>
        </div>
      </div>

      {isChatComingSoon && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex',
          justifyContent: 'center', alignItems: 'center'
        }}>
          <div style={{
            background: '#1e293b', padding: '40px', borderRadius: '16px',
            textAlign: 'center', maxWidth: '400px', width: '90%', color: '#fff',
            boxShadow: '0 10px 30px rgba(0,0,0,0.5)', position: 'relative'
          }}>
            <div
              onClick={() => setIsChatComingSoon(false)}
              style={{ position: 'absolute', top: '15px', right: '15px', cursor: 'pointer', fontSize: '20px', color: '#94a3b8' }}
            >
              <IoMdClose />
            </div>
            <div style={{ fontSize: '50px', marginBottom: '20px' }}>🚀</div>
            <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>Chat is Coming Soon!</h3>

            <button
              onClick={() => setIsChatComingSoon(false)}
              style={{
                background: 'linear-gradient(90deg, #6366f1, #8b5cf6)', border: 'none',
                padding: '10px 24px', borderRadius: '8px', color: '#fff', fontWeight: 'bold',
                cursor: 'pointer', width: '100%'
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
